/* myfence — before/after slider + mobile nav toggle */
(function () {
  function initBA(wrap) {
    if (wrap.dataset.mfBaInit) return;
    wrap.dataset.mfBaInit = '1';
    var after = wrap.querySelector('.mf-ba-after');
    var handle = wrap.querySelector('.mf-ba-handle');
    var dragging = false;

    function setPos(clientX) {
      var r = wrap.getBoundingClientRect();
      var p = Math.max(0, Math.min(100, ((clientX - r.left) / r.width) * 100));
      wrap.style.setProperty('--mf-pos', p + '%');
      if (after) after.style.clipPath = 'inset(0 0 0 ' + p + '%)';
      if (handle) handle.style.left = p + '%';
    }

    function down(e) { dragging = true; setPos(e.touches ? e.touches[0].clientX : e.clientX); }
    function move(e) { if (dragging) setPos(e.touches ? e.touches[0].clientX : e.clientX); }
    function up() { dragging = false; }

    wrap.addEventListener('mousedown', down);
    wrap.addEventListener('touchstart', down, { passive: true });
    window.addEventListener('mousemove', move);
    window.addEventListener('touchmove', move, { passive: true });
    window.addEventListener('mouseup', up);
    window.addEventListener('touchend', up);
  }

  function initTabs(root) {
    if (root.dataset.mfTabsInit) return;
    root.dataset.mfTabsInit = '1';
    var tabs = root.querySelectorAll('[data-mf-tab]');
    var panels = root.querySelectorAll('[data-mf-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-mf-tab');
        tabs.forEach(function (t) { t.classList.toggle('active', t === tab); });
        panels.forEach(function (p) { p.classList.toggle('active', p.getAttribute('data-mf-panel') === id); });
      });
    });
  }

  function initGallery(root) {
    if (root.dataset.mfGalleryInit) return;
    root.dataset.mfGalleryInit = '1';
    var main = root.querySelector('[data-mf-gallery-main]');
    root.querySelectorAll('[data-mf-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-mf-thumb');
        if (main && src) main.src = src;
        root.querySelectorAll('[data-mf-thumb]').forEach(function (t) { t.classList.toggle('active', t === thumb); });
      });
    });
  }

  function init() {
    document.querySelectorAll('.mf-ba').forEach(initBA);
    document.querySelectorAll('[data-mf-tabs]').forEach(initTabs);
    document.querySelectorAll('[data-mf-gallery]').forEach(initGallery);

    // Mobile nav toggle (header)
    document.querySelectorAll('[data-mf-nav-toggle]').forEach(function (btn) {
      if (btn.dataset.mfNavInit) return;
      btn.dataset.mfNavInit = '1';
      btn.addEventListener('click', function () {
        var nav = document.querySelector('.mf-mobile-nav');
        var bd = document.querySelector('.mf-mobile-backdrop');
        if (nav) nav.classList.toggle('open');
        if (bd) bd.classList.toggle('open');
      });
    });
    document.querySelectorAll('[data-mf-nav-close], .mf-mobile-backdrop').forEach(function (el) {
      if (el.dataset.mfNavCloseInit) return;
      el.dataset.mfNavCloseInit = '1';
      el.addEventListener('click', function () {
        var nav = document.querySelector('.mf-mobile-nav');
        var bd = document.querySelector('.mf-mobile-backdrop');
        if (nav) nav.classList.remove('open');
        if (bd) bd.classList.remove('open');
      });
    });

    initSearch();
    initRatingSync();
    initFaq();

    // Mobile menu: tap a group header to expand its dropdown (desktop uses hover).
    // Height is driven in explicit px so the max-height transition is reliable
    // (a pure CSS `.open { max-height: <vh> }` toggle did not animate in the drawer).
    document.querySelectorAll('.mf-mobile-nav .mf-has-dropdown > .mf-nav-top').forEach(function (top) {
      if (top.dataset.mfMnavInit) return;
      top.dataset.mfMnavInit = '1';
      var item = top.parentElement;
      var drop = item.querySelector('.mf-dropdown');
      top.addEventListener('click', function (e) {
        // Titel navigiert zur Oberpunkt-Seite; nur die rechte Pfeil-Zone (56px)
        // klappt auf/zu. Punkte ohne echtes Linkziel ('#') klappen immer auf.
        var href = top.getAttribute('href');
        var rect = top.getBoundingClientRect();
        var caretZone = e.clientX > 0 && (rect.right - e.clientX) <= 56;
        if (!caretZone && href && href !== '#') return;
        e.preventDefault();
        if (!drop) { item.classList.toggle('open'); return; }
        if (item.classList.contains('open')) {
          item.classList.remove('open');
          drop.style.transition = 'none';
          drop.style.height = drop.offsetHeight + 'px';
          void drop.offsetHeight;                              // commit current height
          drop.style.transition = 'height .3s ease';
          drop.style.height = '0px';
          faqDone(drop, function () { drop.style.transition = ''; });
        } else {
          item.classList.add('open');
          drop.style.transition = 'none';
          drop.style.height = 'auto';
          var target = drop.offsetHeight;                      // natural height
          drop.style.height = '0px';
          void drop.offsetHeight;                              // force reflow
          drop.style.transition = 'height .3s ease';
          drop.style.height = target + 'px';
          faqDone(drop, function () { drop.style.height = 'auto'; drop.style.transition = ''; });
        }
      });
    });

    // Randomise + trim product pools (e.g. bestseller from a collection)
    document.querySelectorAll('[data-mf-shuffle]').forEach(function (grid) {
      if (grid.dataset.mfShuffleInit) return;
      grid.dataset.mfShuffleInit = '1';
      var keep = parseInt(grid.getAttribute('data-mf-shuffle'), 10) || 4;
      var items = Array.prototype.slice.call(grid.children);
      for (var i = items.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        grid.appendChild(items[j]);
        items.splice(j, 1);
      }
      Array.prototype.slice.call(grid.children).forEach(function (el, idx) {
        el.style.display = idx < keep ? '' : 'none';
      });
    });
  }

  /* ---- Rating synced from the official Trusted Shops badge (single source of truth) ----
     The eTrusted Trustbadge renders its grade as plain text in the minimized badge,
     OUTSIDE the cross-origin iframe (e.g. "Käuferschutz 4,47 Gut"), so we can read the
     exact value the badge shows and mirror it into every [data-mf-rating] spot. This
     guarantees header, hero, trust strip, footer etc. never contradict the badge.
     (The old public REST v2 API returned a different aggregate — hence the old mismatch.) */
  function readBadgeRating() {
    var el = document.querySelector('[id^="minimized-trustbadge-"], [id^="trustbadge-container-"]');
    if (!el) return null;
    var m = (el.textContent || '').match(/(\d{1,2})[.,](\d{1,2})/);
    return m ? m[1] + ',' + m[2] : null; // normalise to de-DE comma
  }

  function applyRating(value) {
    if (!value) return false;
    var nodes = document.querySelectorAll('[data-mf-rating]');
    if (!nodes.length) return false;
    nodes.forEach(function (el) {
      if (el.dataset.mfRatingApplied === value) return;
      // replace only the first number (the grade); keeps suffixes like "/ 5 · 5.000+ Kunden"
      el.innerHTML = el.innerHTML.replace(/\d{1,2}[.,]\d{1,2}/, value);
      el.dataset.mfRatingApplied = value;
    });
    return true;
  }

  function initRatingSync() {
    if (!document.querySelector('[data-mf-rating]')) return;
    // 1) Paint instantly from the last known badge value — no flicker on repeat views.
    try {
      var cached = sessionStorage.getItem('mfTsRating');
      if (cached) applyRating(cached);
    } catch (e) {}
    // 2) Read the live value from the badge once it has rendered (it loads async).
    var tries = 0;
    function tick() {
      var v = readBadgeRating();
      if (!v) return false;
      applyRating(v);
      try { sessionStorage.setItem('mfTsRating', v); } catch (e) {}
      return true;
    }
    if (tick()) return;
    var iv = setInterval(function () {
      if (tick() || ++tries > 40) clearInterval(iv); // poll up to ~20s for the badge
    }, 500);
  }

  /* ---- Live (predictive) search ---- */
  function initSearch() {
    var panel = document.querySelector('[data-mf-search]');
    if (!panel || panel.dataset.mfSearchInit) return;
    panel.dataset.mfSearchInit = '1';

    var backdrop = document.querySelector('.mf-search-backdrop');
    var input = panel.querySelector('[data-mf-search-input]');
    var results = panel.querySelector('[data-mf-search-results]');
    var base = (panel.getAttribute('data-search-url') || '/search/suggest').replace(/\/$/, '');
    var searchPage = panel.getAttribute('data-search-page') || '/search';
    var timer = null;

    function open() {
      panel.classList.add('open');
      if (backdrop) backdrop.classList.add('open');
      setTimeout(function () { if (input) input.focus(); }, 60);
    }
    function close() {
      panel.classList.remove('open');
      if (backdrop) backdrop.classList.remove('open');
    }
    function money(v) {
      var n = parseFloat(v);
      if (!n || isNaN(n)) return '';
      return n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }
    function thumb(p) {
      var u = (p.featured_image && p.featured_image.url) || p.image || '';
      if (!u) return '<span class="mf-search-thumb"></span>';
      u = u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=120';
      return '<img class="mf-search-thumb" src="' + u + '" alt="" loading="lazy" width="52" height="52">';
    }
    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

    function render(products, q) {
      if (!products || !products.length) {
        results.innerHTML = '<div class="mf-search-empty">Keine Treffer für „' + esc(q) + '".</div>';
        return;
      }
      var html = products.map(function (p) {
        var price = money(p.price_min != null ? p.price_min : p.price);
        return '<a class="mf-search-item" href="' + p.url + '">' + thumb(p) +
          '<span class="mf-search-item-body"><span class="mf-search-item-title">' + esc(p.title) + '</span>' +
          (price ? '<span class="mf-search-item-price">ab ' + price + '</span>' : '') + '</span></a>';
      }).join('');
      html += '<a class="mf-search-all" href="' + searchPage + '?q=' + encodeURIComponent(q) + '">Alle Ergebnisse anzeigen →</a>';
      results.innerHTML = html;
    }

    function query(q) {
      if (!q || q.length < 2) { results.innerHTML = ''; return; }
      var url = base + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var prods = (data.resources && data.resources.results && data.resources.results.products) || [];
          render(prods, q);
        })
        .catch(function () { results.innerHTML = '<div class="mf-search-empty">Suche momentan nicht verfügbar.</div>'; });
    }

    document.querySelectorAll('[data-mf-search-toggle]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    document.querySelectorAll('[data-mf-search-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    if (input) {
      input.addEventListener('input', function () {
        clearTimeout(timer);
        var q = input.value.trim();
        timer = setTimeout(function () { query(q); }, 220);
      });
    }
  }

  /* ---- FAQ accordion: only one open at a time, animated ----
     Native <details> doesn't auto-close siblings and can't transition its own
     reveal, so we drive height + opacity manually. A forced reflow between the
     start and end height makes the transition reliable; a safety timeout
     finalises the state even if `transitionend` doesn't fire. */
  var FAQ_MS = 300;
  function faqDone(answer, cb) {
    var fired = false;
    function finish() { if (fired) return; fired = true; answer.removeEventListener('transitionend', te); cb(); }
    function te(ev) { if (ev.target === answer && ev.propertyName === 'height') finish(); }
    answer.addEventListener('transitionend', te);
    setTimeout(finish, FAQ_MS + 60);
  }
  // Works for the homepage FAQ (.mf-faq-item) AND the base-theme FAQ
  // (.section-faq .accordion-a > details) so both share one animated, single-open behaviour.
  function faqAnswer(item) { return item.querySelector(':scope > .mf-faq-a, :scope > *:not(summary)'); }
  function faqSummary(item) { return item.querySelector(':scope > .mf-faq-q, :scope > summary'); }
  function faqGroup(item) { return item.closest('.accordion-a') || item.parentElement; }
  function faqItems() { return document.querySelectorAll('.mf-faq-item, .section-faq .accordion-a > details'); }
  function faqOpen(item) {
    var answer = faqAnswer(item);
    if (!answer) { item.setAttribute('open', ''); return; }
    item.setAttribute('open', '');
    answer.style.transition = 'none';
    answer.style.overflow = 'hidden';
    answer.style.height = 'auto';
    var target = answer.offsetHeight;          // natural height in px
    answer.style.height = '0px';
    answer.style.opacity = '0';
    void answer.offsetHeight;                   // force reflow so 0 is committed
    answer.style.transition = 'height ' + FAQ_MS + 'ms ease, opacity ' + FAQ_MS + 'ms ease';
    answer.style.height = target + 'px';
    answer.style.opacity = '1';
    faqDone(answer, function () {
      answer.style.height = 'auto';
      answer.style.overflow = '';
      answer.style.transition = '';
    });
  }
  function faqClose(item) {
    var answer = faqAnswer(item);
    if (!answer) { item.removeAttribute('open'); return; }
    answer.style.transition = 'none';
    answer.style.overflow = 'hidden';
    answer.style.height = answer.offsetHeight + 'px';
    void answer.offsetHeight;                   // force reflow
    answer.style.transition = 'height ' + FAQ_MS + 'ms ease, opacity ' + FAQ_MS + 'ms ease';
    answer.style.height = '0px';
    answer.style.opacity = '0';
    faqDone(answer, function () {
      item.removeAttribute('open');
      answer.style.height = '';
      answer.style.overflow = '';
      answer.style.transition = '';
      answer.style.opacity = '';
    });
  }
  function initFaq() {
    var items = faqItems();
    if (!items.length) return;
    items.forEach(function (item) {
      if (item.dataset.mfFaqInit) return;
      item.dataset.mfFaqInit = '1';
      var summary = faqSummary(item);
      if (!summary) return;
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = item.hasAttribute('open');
        var group = faqGroup(item);
        // Accordion: close every other open item in the same group first.
        faqItems().forEach(function (other) {
          if (other !== item && other.hasAttribute('open') && faqGroup(other) === group) faqClose(other);
        });
        if (isOpen) faqClose(item); else faqOpen(item);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-init in the Shopify theme editor when sections are re-rendered.
  document.addEventListener('shopify:section:load', init);
})();
